import { Component, OnInit } from '@angular/core';
import { Stagiaire } from '../stagiaire';
import { GestionStagiairesService } from '../gestion-stagiaires.service';

@Component({
  selector: 'app-liste-stagiaires',
  templateUrl: './liste-stagiaires.component.html',
  styleUrls: ['./liste-stagiaires.component.css']
})
export class ListeStagiairesComponent implements OnInit {

  private message: string;
  private messageClass: string;
  private listStagiaires: Array<Stagiaire>;

  constructor(
    private service: GestionStagiairesService,
  ) { }

  private getAllStagiaires(): void {
  let results;
      this.service.loadStagiaires().subscribe(data => {
              results = data;
              /*
              if (results.success === false) {
                  this.messageClass = 'alert alert-danger';
                  this.message = results.message;
              }else {
                  this.listStagiaires = results;
              }
              */
              this.listStagiaires = results;
      });
  }

  public updateEntreprise(stagiaireUpdate: Stagiaire): void {
    this.service.updateStagiaire(stagiaireUpdate).subscribe(data => {
              if (!data.success) {
                  this.messageClass = 'alert alert-danger';
                  this.message = data.message;
              }else {
                  this.messageClass = 'alert alert-success';
                  this.message = data.message;
              }
      });
  }

  public deleteEntreprise(id: number): void {
    this.service.deleteStagiaire(id).subscribe(data => {
              if (!data.success) {
                  this.messageClass = 'alert alert-danger';
                  this.message = data.message;
              }else {
                  this.messageClass = 'alert alert-success';
                  this.message = data.message;
              }
      });
  }

  ngOnInit() {
    this.getAllStagiaires();
  }
}



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/gestion-stagiaires/liste-stagiaires/liste-stagiaires.component.ts